import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-print-gstreport',
  templateUrl: './print-gstreport.component.html',
  styleUrls: ['./print-gstreport.component.scss'],
})
export class PrintGSTReportComponent implements OnInit {
  receiptledger;
  total_amt;
  startdate: any;
  enddate: any;
  months: string[] = [];
  

  constructor(
    private dialogref: MatDialogRef<PrintGSTReportComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit(): void {
    
    this.receiptledger = this.data['val'];
    this.total_amt = this.data['totalamt'];
    this.startdate = this.data['startdate'];
    this.enddate = this.data['enddate'];

    console.log(this.startdate, this.enddate)
    this.calculateMonths(this.startdate, this.enddate);


  }
  calculateMonths(start: string, end: string): void {
    const startDate = new Date(start);
    const endDate = new Date(end);

    const monthNames = [
      "January", "February", "March", "April", "May", "June",
      "July", "August", "September", "October", "November", "December"
    ];

    const startMonth = startDate.getMonth();
    const startYear = startDate.getFullYear();
    const endMonth = endDate.getMonth();
    const endYear = endDate.getFullYear();

    for (let year = startYear; year <= endYear; year++) {
      let monthStart = year === startYear ? startMonth : 0;
      let monthEnd = year === endYear ? endMonth : 11;

      for (let month = monthStart; month <= monthEnd; month++) {
        this.months.push(monthNames[month]);
      }
    }

    console.log(this.months.join(', ')); // Example output: "April, May, June"
  }

show=false 
printPage() {
  this.show = true;

  const element = document.getElementById('print-section');
  if (!element) {
    console.error("Print section not found!");
    return;
  }

  const printContent = element.innerHTML;

  const printWindow = window.open('', '', 'width=1400,height=1000');

  if (printWindow) {
    printWindow.document.open();
    printWindow.document.write(`
      <html>
        <head>
          <title>Print Report</title>

          <style>
            body {
              font-family: Arial, sans-serif;
              margin: 0;
              padding: 10px;
              color: black !important;
            }

            h2 {
              text-align: center;
              margin: 10px 0;
              color: black !important;
            }

            /* 🔥 CONVERT DIV LAYOUT TO TABLE */
            .container {
              width: 100%;
            }

            .row {
              display: flex;
              width: 100%;
            }

            .row:first-child {
              display: block;
            }

            /* Columns */
            .col { width: 5%; }
            .col1 { width: 12%; }
            .col2 { width: 18%; }
            .col3 { width: 25%; }

            .col, .col1, .col2, .col3 {
              border: 1px solid black;
              padding: 4px;
              text-align: center;
              font-size: 12px;
              color: black !important;
              box-sizing: border-box;
            }

            /* Header row */
            .row:nth-child(2) div {
              font-weight: bold;
              background: #fff;
            }

            @media print {
              @page {
                size: A3 landscape;
                margin: 8mm;
              }

              .noPrint {
                display: none !important;
              }

              .row {
                page-break-inside: avoid;
              }
            }
          </style>

        </head>

        <body>
          <div id="print-section">
            ${printContent}
          </div>

          <script>
            window.onload = function () {
              window.print();
              setTimeout(() => window.close(), 500);
            };
          </script>
        </body>
      </html>
    `);

    printWindow.document.close();
  } else {
    console.error("Failed to open print window.");
  }
}
}
